<router-outlet></router-outlet>
<div class="spinner-overlay" *ngIf="spinnerOverlayService.isLoading$ | async">
  <div class="spinner-content">
    <div class="spinner-loader"></div>
    <p>Cargando...</p>
  </div>
</div>
